const REACT_APP_BASE_API_URL = "/api";
const REACT_APP_BASE_SOCKET_URL = import.meta.env.VITE_APP_BASE_SOCKET_URL;
export default {
  port: 8110,
  bpm: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/smartbpm/",
    SSL: true,
    port: 443,
    hostSemPorta: REACT_APP_BASE_API_URL,
  },
  ecm: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/nuxeo/",
    documentsPrefix: "/smartbpm/documents/",
    user: "Administrator",
    password: "Administrator",
    workspace: "asbpm",
  },
  drive: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/smartecm/",
  },
  socket: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/socket.io/",
  },

  umbrella: {
    key: "X-Api-Key",
    value: "7b9nBSEbAYorYo0os2vpW3CaHrg8A3jaceA5eqik",
  },
  report: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/smartreport/report",
  },
  proxy: {
    target: REACT_APP_BASE_API_URL,
    changeOrigin: true,
  },
  notification: {
    host: REACT_APP_BASE_SOCKET_URL,
    prefix: "smart-socket/socket",
  },
  category: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/smartreport/category",
  },
  LacunaLicense:
    "AiMAKi5zbWFydGRvY3MuY29tLmJyLCouc29zZG9jcy5jb20uYnJDAGlwNDoxMC4wLjAuMC84LGlwNDoxMjcuMC4wLjAvOCxpcDQ6MTcyLjE2LjAuMC8xMixpcDQ6MTkyLjE2OC4wLjAvMTYDAFBybwgAABi/O5Tp3ggAAbRMepfAVvmZkvS2sJs1Oj1rmYLfqONuL7rBA9nb9DVhpdDBPm4MjWgKG03oADpUSfPPdNVYDVqS2cNHIdoexAzf4n3ad3sSBIDjuN1GUk1W5ea4bJUowbecmnh9UeKdfJweuxe9GOn82/lLWoS7SjyEbcrAeiiH+DKOQyhnS5WdBLjwUeB6+nT6Tyek+kbtS/Zlnm+HauJJ16NvAvmGz/yYfaXQVjbAXwpAH15Xj+OhtOgs/Wu21DoBL/dWndYWWllyzG1Twxdf4RYggPBvM4pcAeqR1R+lNUyRFTtkfF5jP7xal9fNCBEhEa4kr38d/yzZdeU4gORnlY9HY8ftaco=",
  "Dynamsoft.WebTwainEnv.ProductKey":
    "t01888AUAAApYZX4BewXEuJ22vQarHMhnE1AvgcPw3S5aqXwtb0WIZwpHrLboIig7j0hSEsT6hbeozxtuHGlk0bRoXVxQnc7xy4kFTpnvFJrv5AVO3HISvXLoy26bnJcSEIF3BuQ4DgfALVBq6YCPrbWxBkADRAFEq4E14HIV488H9Q3Sfv1nQ5MTC5wy39k2yBwnL3DiljM0yDM0xTesdisAtyfnBEAD5BLgepENDUI9AA2QASBnYMW4HfJQKfE=",
  "Dynamsoft.WebTwainEnv.Trial": true,
  "Dynamsoft.WebTwainEnv.ResourcesPath":
    "../../../../../../../../../vendor/dwt/dist",
  "Flexmonster.LicenseKey": "Z7OR-XCH616-4N5U2I-6W0M6X",
  "Video-Call-Server": "chat.fourcicle.com",
  UsarAssinatura: false,
  syncfusionKey:
    "Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZecnVQRWReVEZxWkZWYEE=",
  //  Adição vinda do projeto SmartDocz
  acessoDados: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/acesso-dados/",
  },
  identidade: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/identidade/",
  },
  documentos: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/documentos/",
  },

  smartform: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/smartform/",
  },
  diploma: {
    host: REACT_APP_BASE_API_URL,
    prefix: "/diploma-digital/",
  },
};
